export default {
  // Sidebar and Toolbar buttons
  ADD: "interfaceIdentifiers:ADD",
  SEARCH: "interfaceIdentifiers:SEARCH",
  FILTER: "interfaceIdentifiers:FILTER",
  BOOKMARKS: "interfaceIdentifiers:BOOKMARKS",
  MARKERS: "interfaceIdentifiers:MARKERS",
  SYNC: "interfaceIdentifiers:SYNC",
  SETTINGS: "interfaceIdentifiers:SETTINGS",
  CONSTRAINTS: "interfaceIdentifiers:CONSTRAINTS",
  ADVANCED_SETTINGS: "interfaceIdentifiers:ADVANCED_SETTINGS",
  UNDO: "interfaceIdentifiers:UNDO",
  REDO: "interfaceIdentifiers:REDO",
  TUTORIALS: "interfaceIdentifiers:TUTORIALS",
  IOS_VIEW_DETAILS: "interfaceIdentifiers:IOS_VIEW_DETAILS",
  IOS_EDIT: "interfaceIdentifiers:IOS_EDIT",
  IOS_MORE: "interfaceIdentifiers:IOS_MORE",

  // View Type toolbar buttons
  TIMELINE: "interfaceIdentifiers:TIMELINE",
  SPREADSHEET: "interfaceIdentifiers:SPREADSHEET",
  RELATIONSHIP: "interfaceIdentifiers:RELATIONSHIP",
  SUBWAY: "interfaceIdentifiers:SUBWAY",
  NARRATIVE: "interfaceIdentifiers:NARRATIVE",
  OUTLINE: "interfaceIdentifiers:OUTLINE",
  MINDMAP: "interfaceIdentifiers:MINDMAP",
  MOBILE_CHRONOLOGICAL_LIST: "interfaceIdentifiers:MOBILE_CHRONOLOGICAL_LIST",
  MOBILE_NARRATIVE_LIST: "interfaceIdentifiers:MOBILE_NARRATIVE_LIST",

  // Inspector Identifiers
  INSPECTOR_DATES_TAB: "interfaceIdentifiers:INSPECTOR_DATES_TAB",
  INSPECTOR_CONSTRAINTS_TAB: "interfaceIdentifiers:INSPECTOR_CONSTRAINTS_TAB",
  INSPECTOR_RELATIONSHIPS_TAB: "interfaceIdentifiers:INSPECTOR_RELATIONSHIPS_TAB",
  INSPECTOR_PROPERTIES_TAB: "interfaceIdentifiers:INSPECTOR_PROPERTIES_TAB",
  INSPECTOR_ATTACHMENTS_TAB: "interfaceIdentifiers:INSPECTOR_ATTACHMENTS_TAB",
  INSPECTOR_NARRATIVE_SECTION_TYPE: "interfaceIdentifiers:INSPECTOR_NARRATIVE_SECTION_TYPE",
  INSPECTOR_BLOCKED_BY_PLUS: "interfaceIdentifiers:INSPECTOR_BLOCKED_BY_PLUS",
  INSPECTOR_DATE_CONSTRAINTS_PLUS: "interfaceIdentifiers:INSPECTOR_DATE_CONSTRAINTS_PLUS",
  INSPECTOR_TYPE: "interfaceIdentifiers:INSPECTOR_TYPE",

  // Footer Icons
  FOOTER_TIMELINE_SHOW_DEPENDENCIES: "interfaceIdentifiers:FOOTER_TIMELINE_SHOW_DEPENDENCIES",
  FOOTER_TIMELINE_LAYOUT: "interfaceIdentifiers:FOOTER_TIMELINE_LAYOUT",
  FOOTER_TIMELINE_SHOW_TODAY: "interfaceIdentifiers:FOOTER_TIMELINE_SHOW_TODAY",
  FOOTER_TIMELINE_SHOW_TYPES: "interfaceIdentifiers:FOOTER_TIMELINE_SHOW_TYPES",
  FOOTER_TIMELINE_GROUP_BY: "interfaceIdentifiers:FOOTER_TIMELINE_GROUP_BY",
  FOOTER_TIMELINE_ZOOM: "interfaceIdentifiers:FOOTER_TIMELINE_ZOOM",
  FOOTER_TIMELINE_RANGE: "interfaceIdentifiers:FOOTER_TIMELINE_RANGE",
  FOOTER_LOCK_SCROLLING: "interfaceIdentifiers:FOOTER_LOCK_SCROLLING",
  FOOTER_CARD_DETAILS: "interfaceIdentifiers:FOOTER_CARD_DETAILS",

  // Entity Panel
  ENTITY_PANEL_ADD: "interfaceIdentifiers:ENTITY_PANEL_ADD",
  ENTITY_PANEL_FILTER: "interfaceIdentifiers:ENTITY_PANEL_FILTER",

  // Filter Panel
  FILTER_PANEL_ALL_VIEWS: "interfaceIdentifiers:FILTER_PANEL_ALL_VIEWS",
  FILTER_PANEL_FOCUSED_VIEW: "interfaceIdentifiers:FILTER_PANEL_FOCUSED_VIEW",

  // Sync Panel
  SYNC_PANEL_SETTINGS: "interfaceIdentifiers:SYNC_PANEL_SETTINGS",
  SYNC_PANEL_SYNC_NOW: "interfaceIdentifiers:SYNC_PANEL_SYNC_NOW",

  // Table View
  TABLE_VIEW_DRAG_HANDLE: "interfaceIdentifiers:TABLE_VIEW_DRAG_HANDLE"
};
